import { req, post } from '@/plugins/axios'

/**
* 获取推荐店铺列表
* @param {Object} data
*/
export function getRecommendShopList (data: any) {
  return post('/goods/recommend/supplier', data)
}

/**
* 店铺添加收藏
* @param {Object} data
*/
export function shopFavorite (data: any) {
  return req('/goods/favorite/shop/add', data)
}

/**
* 商品取消收藏
* @param {Object} data
*/
export function shopFavoriteCancel (data: any) {
  return req('/goods/favorite/shop/cancel', data)
}

/**
* 操作店铺喜欢和不喜欢
* @param {Object} data
*/
export function handleShopBehavior (data: any) {
  return post('/goods/behavior/shop', data)
}

/**
* 获取收藏的店铺列表
* @param {Object} data
*/
export function getFavoriteShopList (data: any) {
  return post('/goods/favorite/shop/list', data)
}

/**
* 获取看过的店铺列表
* @param {Object} data
*/
export function getLookShopList (data: any) {
  return post('/goods/footprint/footprint/shop', data)
}

/**
* 获取买过的店铺列表
* @param {Object} data
*/
export function getBuyShopList (data: any) {
  return post('/goods/footprint/bought/shop', data)
}

/**
* 获取担当推荐的店铺
* @param {Object} data
*/
export function getConfigRecommendShop (data: any) {
  return post('/goods/footprint/strategy/shop', data)
}

/**
* 获取店铺信息和商品
* @param {Object} data
*/
export function getShopDetail (data: any) {
  return post('/goods/search/suppliers', data)
}

export const getWhiteShops = () => {
  return req('/settlement/allInclude/customer/whiteListShop', {})
}
